export default __webpack_public_path__ + "static/media/checkSuccessBadge.59f5a352.svg";